export default {
  alerts: {
    unknown: 'unbekannte Wallet', basis: '24-Std.-Veränderung', check: '~30 s',
    flow: { inflow: 'Einzahlung an die Börse', outflow: 'Abhebung von der Börse' },
    err: { maxNets_one: 'Du kannst höchstens {{count}} Netzwerk wählen.', maxNets_other: 'Du kannst höchstens {{count}} Netzwerke wählen.', enableFirst: 'Schalte zuerst OrcaWatch ein.' },
    notice: {
      price: 'Preis {{price}} · Stufe {{level}} in 24 Std. erreicht', test: 'Test', testBody: 'So sieht eine dringende Benachrichtigung von Orca aus',
      n4: { title: 'Wall Street · Pre-Market', body: 'Futures steigen, im Fokus die NVIDIA-Zahlen und das FOMC-Protokoll' },
      n5: { title: 'News zu deinen Coins', body: '11 Meldungen · BTC, ETH, SOL, TON, LINK' },
      n6: { title: 'Morgen: FOMC-Protokoll', body: 'Hohe Relevanz für BTC, ETH und Indizes' },
      n7: { title: 'X Radar · 3 wichtige Posts', body: 'Vitalik Buterin, Solana, Chainlink — die stündliche Auswahl' },
    },
  },
};
